<div class="modal-parent-container placeholder-glow">
    <div class="text-center mb-1">
        <span class="text-center fw-bold modal-title">Send Comm</span> (<span class="modal-title">{{utility.getSubStr(data.name, 20, {isDots: true})}}</span>)
    </div>
    <div class="row form-group" style="align-items: center;">
        <div class="col-12">
            <label for="rewardAmount">Reward Amount</label>
            <input type="text" id="rewardAmount" class="form-control" placeholder="Enter reward amount" [(ngModel)]="rewardAmount" />
        </div>
        <!-- <div class="col-3">
            <input type="checkbox" id="sendToShared" [(ngModel)]="sendToShared" />
            <label for="sendToShared">Send to Shared</label>
        </div>
        <div class="col-3">
            <input type="checkbox" id="sendToExclusive" [(ngModel)]="sendToExclusive" />
            <label for="sendToExclusive">Send to Exclusive</label>
        </div> -->
    </div>
    <div class="row form-group" *ngFor="let mode of selectedCommunicationModes; let i = index">
        <div class="col-3" [ngClass]="{ 'placeholder': loading }">
            <label for="communicationMode-{{ i }}">Communication Mode</label>
            <select id="communicationMode-{{ i }}" [ngClass]="{ 'placeholder': loading, 'form-control': !loading }" class="form-control" (change)="onModeChange(i)" [(ngModel)]="mode.type" [disabled]="mode.disabled">
                <ng-container *ngIf="!mode.disabled">
                    <option *ngFor="let availableMode of availableModes" [value]="mode.disabled ? mode.type : availableMode">{{ mode.disabled ? mode.type : availableMode }}</option>
                </ng-container>
                <ng-container *ngIf="mode.disabled">
                    <option [value]="mode.type">{{ mode.type }}</option>
                </ng-container>
            </select>
        </div>
        <div class="col-3" [ngClass]="{ 'placeholder': loading }">
            <label for="templateName-{{ i }}">Template Name</label>
            <select id="templateName-{{ i }}" [ngClass]="{ 'placeholder': loading, 'form-control': !loading }" [(ngModel)]="mode.value">
                <option *ngFor="let template of mode.templates" [value]="template.id">{{ template.template }}</option>
            </select>
        </div>
        <div class="col-3">
            <label for="countType">Choose Quota Type</label>
            <select class="form-control" name="countType" id="countType" [(ngModel)]="mode.quotaType">
                <option value="exclusive">Exclusive</option>
                <option value="shared">Shared</option>
            </select>
        </div>
        <div class="col-3">
            <label for="quotaCount">Count</label>
            <input type="number" id="quotaCount" class="form-control" placeholder="Enter comm count" [(ngModel)]="mode.quotaCount" />
        </div>
        <div class="col-12 text-right mt-2">
            <button *ngIf="i === selectedCommunicationModes.length - 1 && availableModes.length > 1" (click)="addCommunicationMode(i)" class="btn btn-sm btn-secondary p-1">
                <img src="assets/media/icons/plus.png" alt="Add" />
            </button>
            <button *ngIf="selectedCommunicationModes.length > 1" (click)="removeCommunicationMode(i)" class="btn btn-sm btn-warning p-1 ms-1">
                <img src="assets/media/icons/delete.png" alt="Delete" />
            </button>
        </div>
    </div>
    <div class="footer">
        <button class="btn btn-secondary" (click)="close()">Cancel</button>
        <button *ngIf="!schedulingComm" class="btn btn-primary" (click)="sendComm()">Send</button>
        <button *ngIf="schedulingComm" class="btn btn-primary" type="button" disabled>
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Scheduling...
        </button>
    </div>
</div>